import { Amplify } from 'aws-amplify';
import { env } from './utils/utils';

// env() throws when a key is missing but returns '' when it is present and
// blank, which every .env in this repo is by default. Amplify accepts a blank
// identityPoolId and only fails later, when it tries to resolve guest
// credentials, so the symptom is broken images rather than a config error.
// Fail at start-up instead.
const requiredEnv = (key: string) => {
  const value = env(key);

  if (!value) {
    throw new Error(`env config for ${key} is empty`);
  }

  return value;
};

const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: requiredEnv('RIVER_AWS_IDENTITY_POOL_ID'),
        // Providers read and write storage through the unauthenticated identity.
        allowGuestAccess: true,
      },
    },
    Storage: {
      S3: {
        bucket: requiredEnv('RIVER_AWS_BUCKET_NAME'),
        region: requiredEnv('RIVER_AWS_REGION'),
      },
    },
  });
};

export default configureAmplify;
